import { render, staticRenderFns } from "./ProjectAddCard.vue?vue&type=template&id=65248c6f&scoped=true"
import script from "./ProjectAddCard.vue?vue&type=script&lang=js"
export * from "./ProjectAddCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65248c6f",
  null
  
)

export default component.exports